
import { createTheme, useMediaQuery, Typography} from '@mui/material';
import React from 'react'
import { ThemeProvider,  } from 'styled-components';
import Creditstable from '../../components/ManageOrganization/Managecredits/creditsupdateandtable';
const defaultTheme = createTheme();
const Managecredits = () => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  return (
    <ThemeProvider theme={defaultTheme}>
         {isMobile &&( <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: "bold", display: "flex", justifyContent: "center",color:"#A2A2A2"  }}>
        Manage Credits
      </Typography>)}
      <Creditstable />
    </ThemeProvider>
  )
}

export default Managecredits